import * as React from 'react';
import { getPadding, setRect } from '../views/common/utils';
import { BORDER_WIDTH } from '../constants';
var stripSelectorSymbol = function (str) { return str.slice(1, str.length); };
/** @hidden */
export var useRowSync = function (args, inputs) {
    var element = args.element;
    var syncHeight = function () {
        if (!element || !element.current) {
            return;
        }
        var highest = [[]];
        var elements = Array
            .from(element.current.querySelectorAll(args.selector))
            .filter(function (el) { return !el.classList.contains(stripSelectorSymbol(args.applyTo)); });
        elements.forEach(function (el) {
            var height = el.clientHeight;
            var x = el.getAttribute(args.horizontalAttribute);
            var y = el.getAttribute(args.verticalAttribute);
            if (x === null || y === null) {
                return;
            }
            if (!highest[x]) {
                highest[x] = [];
            }
            if (!highest[x][y] || height > highest[x][y]) {
                highest[x][y] = height - BORDER_WIDTH;
            }
        });
        var targets = Array.from(element.current.querySelectorAll(args.applyTo));
        targets.forEach(function (el) {
            var x = el.getAttribute(args.horizontalAttribute);
            var y = el.getAttribute(args.verticalAttribute);
            if (x === null || y === null) {
                return;
            }
            var slotPadding = getPadding(el);
            var height = highest[x][y] - slotPadding;
            setRect(el, { height: height }, true);
        });
    };
    React.useEffect(syncHeight, inputs);
};
//# sourceMappingURL=useRowSync.js.map